import '../src/javascripts/flatpickr';
